module.exports = __webpack_public_path__ + "img/chuang1.4b34eb94.png";